import { SnowplowTrigger } from 'Snowplow'
import clickEventName from 'utils/DOM/clickEventName'
import { registerSnowplowTriggers } from 'utils/snowplow/events/userClick/registerSnowplowTriggers'

const quotesEvents: SnowplowTrigger[] = [
  {
    element: '#continue-form',
    description: 'Census - profile details',
    elementTrigger: clickEventName,
    eventType: 'click',
    placement: 'form-step-3'
  }
]

export default function registerSnowplowListeners() {
  registerSnowplowTriggers(quotesEvents)
}
